<template>
  <div></div>
</template>

<script>
  export default {
    name: "NotificationUnread",
    components: {
    },
    data() {
      return {
        unreadCount: 0,
        unreadCountNotification: 0,
        totalUnread: 0,
      }
    },

    mounted() {
      this.GetFeedbackUnreadCount()
      this.GetNotificationUnreadCount()
    },

    activated() {
      this.GetFeedbackUnreadCount()
      this.GetNotificationUnreadCount()
    },

    methods: {
      GetFeedbackUnreadCount() {
        this.$store.dispatch("GetCachedFeedbackUnreadCount").then(data => {
          if (data.code === 0) {
            this.unreadCount = data.data.count
          }
        }, ()=> {
        })
      },
      GetNotificationUnreadCount() {
        this.$store.dispatch("GetNotificationUnreadCount").then(data => {
          if (data.code === 0) {
            this.unreadCountNotification = data.data.count
          }
        }, ()=> {
        })
      },
    },

    computed: {
      unreadCountDisplay() {
        if (this.unreadCount + this.unreadCountNotification) {
          return this.unreadCount + this.unreadCountNotification
        } else {
          return ""
        }
      }
    },
    watch: {
      unreadCount(newVal) {
        this.$emit("updateUnreadCount", this.unreadCountDisplay)
      },
      unreadCountNotification(newVal) {
        this.$emit("updateUnreadCount", this.unreadCountDisplay)
      }
    }
  };
</script>

<style scoped>


</style>
